<template>
  <svg
    viewBox="0 0 50 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :heigth="size"
  >
    <path
      d="M28.3718 28.8009L48.5896 8.27998C49.0365 7.83005 49.3913 7.29476 49.6333 6.70498C49.8754 6.1152 50.0001 5.4826 50.0001 4.84369C50.0001 4.20477 49.8754 3.57217 49.6333 2.98239C49.3913 2.39261 49.0365 1.85732 48.5896 1.40739C47.6962 0.505965 46.4876 0 45.2279 0C43.9682 0 42.7596 0.505965 41.8662 1.40739L24.9863 18.5405L8.10633 1.40739C7.21292 0.505965 6.00437 0 4.74464 0C3.48491 0 2.27637 0.505965 1.38296 1.40739C0.941021 1.85963 0.591381 2.39596 0.354088 2.98564C0.116791 3.57531 -0.00348663 4.20673 0.000141144 4.84369C-0.00348663 5.48064 0.116791 6.11206 0.354088 6.70173C0.591381 7.29141 0.941021 7.82774 1.38296 8.27998L21.6007 28.8009C22.044 29.2546 22.5714 29.6146 23.1525 29.8603C23.7335 30.1061 24.3568 30.2326 24.9863 30.2326C25.6158 30.2326 26.239 30.1061 26.8201 29.8603C27.4011 29.6146 27.9285 29.2546 28.3718 28.8009Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
import mixinIcon from '../mixinIcon'

export default {
  name: 'Arrow',
  mixins: [mixinIcon]
}
</script>
